import React, { HTMLAttributes } from "react";
import styled from "styled-components";
import { HEIGHT, MOBILE_HEIGHT } from "./Header/constants";
import { media, maxWidth } from "./theme";
import Content from "./common/Content";
import HeaderWithIntro from "./common/HeaderWithIntro";
import Breadcrumbs from "./common/TopBox/Breadcrumbs";
import { RouteName } from "../lib/routes";

const IFrame = styled.iframe<{ wide?: boolean }>`
  width: 100%;
  max-width: ${p => (p.wide ? maxWidth.page : 900)}px;
  margin: auto;
  height: calc(80vh - ${HEIGHT}px);
  border: none;
  @media screen and ${media.mobile} {
    height: calc(80vh - ${MOBILE_HEIGHT}px);
  }
  overflow-x: hidden;
  @media screen and ${media.tablet} {
    overlflow-x: initial;
  }
`;

type Props = {
  wide?: boolean;
  title: string;
  description: string;
  route: RouteName;
  src: string;
} & HTMLAttributes<HTMLIFrameElement>;

export default function iFramePage(props: Props) {
  return (
    <>
      <Content padded>
        <Breadcrumbs
          path={[
            {
              title: props.title,
              route: props.route
            }
          ]}
        />
        <HeaderWithIntro
          headline={props.title}
          blue
          noWordBreak
          small
          size={1}
          level={1}
          intro={props.description}
        />
      </Content>
      <Content>
        <IFrame {...props} />
      </Content>
    </>
  );
}
